<template lang="pug">
.item(:class="{ selected: selected }")
  .left
    img(v-if="product.photo", :src="product.photo.image")
  .right
    h5 {{ product.name }}
    p 售價
      span $
      span.price(v-if="product.total_price != '0'") {{ product.total_price }}
      span.price(v-else) 依距離收費
    .add_product_btn(@click="itemClick", :class="{ selected: selected }") {{ selected ? '已加購' : '我要加購' }}
</template>

<script>
export default {
  name: "Product",
  props: {
    product: Object,
  },
  data() {
    return {
      selected: false,
    };
  },
  methods: {
    itemClick() {
      this.selected = !this.selected;
      this.$emit("extraChange", this.product.id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/enroll/product";
</style>
